// Here is forbidden to import i18n or any request.js files
// which will make circular dependency
import keyMirror from 'keymirror'
import { createKeyMirror } from '@/utils'
import { ROUTER_PATHS } from '@/constants/router'
export {
  tenancyRecordsRouteNames,
  tenderRouteNames,
  projectRouteNames,
  performanceRouteNames,
  dashboardRouterNames,
  ccdRouteNames,
  eCircularRouteNames,
  standaloneWpRouteNames,
  directoryRouteNames,
  workPermitRouteNames,
  tenantProjectRouteNames,
} from '@/constants/router'

export const UserType = {
  Staff: {
    Admin: 501,
    User: 521,
    TenderAccount: 561, // Tender Representative
    ProjectRep: 581, // Project Representative
    TenancyRep: 591, // Tenancy Representative
  },
  Vendor: {
    Admin: 401, // Vendor Admin
    User: 421, // Vendor Sub User
    Tmp: 441, // HKL Project Contractor
    TenderAccount: 461, // Tender Representative
    ProjectRep: 481, // Project Representative
  },
  Tenant: {
    Admin: 601, // Tenancy Master User
    User: 621, // Tenancy Sub User
    ProjectUser: 641, // Tenant Representative
    Tmp: 661, // Tenant Project Contractor
    TenancyContractor: 662, // Tenancy Contractor (for Standalone Permit)
  },
}

export const UserDomain = keyMirror({
  CMS: null, // UserDomain For Vendors
  TMS: null, // UserDomain For Tenants
})

export const UserSource = keyMirror({
  AD: null,
  EXT: null,
})

export const AdminRoleName = ['Admin']
export const SysAdminRoleName = ['System Admin']
export const ContractorAdminRoleName = ['Contractor Admin']
export const VendorRolesName = [...ContractorAdminRoleName, 'Contractor Sub']
export const TenantRoleName = [
  'Tenancy Admin Contact', // Tenancy Master User
  'Tenancy Contact', // Tenancy Sub User
  'Tenant Project Contact', // Tenant Project
  'TMS Project Temp Conctractor', // Tenant Project Contractor
  'TMS Standalone Contractor', // Tenancy Standalone Contractor
]
export const DepartmentAdminRoleName = ['Department Admin']
export const TenderAccountRoleName = ['HKL Tender Representative']
export const ProjectRepAccountRoleName = ['HKL Project Representative']
export const TenancyRepAccountRoleName = ['HKL Tenancy Representative']

export const Settings = 'Settings'

export const FOLDER_STATUS = keyMirror({
  DRAFT: null,
  APPR: null,
  REJECTED: null,
})

export const ADDENDUM_PENDING_STATUS = keyMirror({
  DRAFT: null,
  WAPPR: null,
  REJECTED: null,
  APPR: null,
})

export const ADDENDUM_STATUS = keyMirror({
  ...ADDENDUM_PENDING_STATUS,
  ISSUED: null,
})

export const systemUserId = '000000000000000000000000'

export const DocTypes = {
  layoutDrawings: 'As-Fitted Drawing (Layout)',
  diagramDrawings: 'As-Fitted Drawing (Schematic Diagram)',
  otherDrawings: 'As-Fitted Drawing (Others)',
  certificates: 'Certificates',
  forms: 'Statutory Submissions or Forms',
  manual: 'Operation & Maintenance Manual',
  testReport: 'Test Report',
  photoRecord: 'Photo Record',
  warrantyDocument: 'Warranty Document',
  deliveryNote: 'Delivery Note',
  others: 'Others',
}

export const PwdExpirationRule = {
  AGE_IN_DAYS: 90,
  GRACE_DAYS: 14,
}

const EMAIL_HOST_NAME = process.env.EMAIL_HOST_NAME || 'hkland.com'

export const EMAIL_HOST_NAME_SUFFIX = `@${EMAIL_HOST_NAME}`

export const REQUEST_TIMEOUT = Number(process.env.CMS_REQUEST_TIMEOUT) || 300000
export const FILE_TRANSFER_TIMEOUT = Number(process.env.CMS_FILE_TRANSFER_TIMEOUT) || 300000

export const OPEN_MODAL_SLOT = 'openModal'
export const CLOSE_MODAL_SLOT = 'closeModal'

export const EmailTypes = {
  tenders: {
    invitation: 'tenders/invitation',
    extendNotifyVendor: 'tenders/extendNotifyVendor',
    extendNotifyEngineer: 'tenders/extendNotifyEngineer',
    addendum: 'tenders/addendum',
    approvalResult: 'tenders/approvalResult',
    awardVendor: 'tenders/awardVendor',
    regretVendor: 'tenders/regretVendor',
    submitBid: 'tenders/submitBid',
    withdrawBid: 'tenders/withdrawBid',
    submitForApproval: 'tenders/submitForApproval',
    query: 'tenders/query',
    submitQuery: 'tenders/submitQuery',
    queryResponse: 'tenders/queryResponse',
  },
  projects: {
    invitation: 'projects/invitation',
    submissionAcceptance: 'projects/acceptSubmission',
    submissionSubmitted: 'projects/submitSubmission',
    invitePrimaryContact: 'projects/invitePrimaryContact',
  },
  settings: {
    createPassword: 'settings/createPassword',
  },
  tenancies: {
    create: 'tenancies/create',
    requestForInvitation: 'tenancies/requestForInvitation',
    inviteTenantMasterUser: 'tenancies/inviteTenantMasterUser',
    inviteSubAccount: 'tenancies/inviteSubAccount',
    inviteContractor: 'tenancies/inviteContractor',
  },
  handovers: {
    submitForApproval: 'handovers/submitForApproval',
    requestChange: 'handovers/requestChange',
    arrange: 'handovers/arrange',
    unsigned: 'handovers/unsigned',
    complete: 'handovers/complete',
    resetToDraft: 'handovers/resetToDraft',
  },
  takebacks: {
    submitForApproval: 'takebacks/submitForApproval',
    requestChange: 'takebacks/requestChange',
    arrange: 'takebacks/arrange',
    unsigned: 'takebacks/unsigned',
    complete: 'takebacks/complete',
    resetToDraft: 'takebacks/resetToDraft',
  },
  tenantProjects: {
    submitProject: 'tenantProjects/submitProject',
    completeSubmission: 'tenantProjects/completeSubmission',
    completePostfitout: 'tenantProjects/completePostfitout',
    completeGreenFitOut: 'tenantProjects/completeGreenFitOut',
    nextReviewer: 'tenantProjects/nextReviewer',
    reassign: 'tenantProjects/reassign',
    inspectionFollowUp: 'tenantProjects/inspectionFollowUp',
    submitDesignDocs: 'tenantProjects/submitDesignDocs',
    batchStatusChanged: 'tenantProjects/batchStatusChanged',
    depositNotifyPM: 'tenantProjects/depositNotifyPM',
    depositNotifyAccounting: 'tenantProjects/depositNotifyAccounting',
    managementFeeNotifyPM: 'tenantProjects/managementFeeNotifyPM',
    managementFeeNotifyAccounting: 'tenantProjects/managementFeeNotifyAccounting',
    refundNotifyPM: 'tenantProjects/refundNotifyPM',
    refundNotifyAccounting: 'tenantProjects/refundNotifyAccounting',
    requestRefund: 'tenantProjects/requestRefund',
    withdrawTenantProject: 'tenantProjects/withdrawTenantProject',
    invitePrimaryContact: 'tenantProjects/invitePrimaryContact',
    completeFinalDocuments: 'tenantProjects/completeFinalDocuments',
    exemptFinalDocuments: 'tenantProjects/exemptFinalDocuments',
  },
  workPermits: {
    firstApplyWP: 'workPermits/firstApplyWP',
    applyWP: 'workPermits/applyWP',
    applyHoisting: 'workPermits/applyHoisting',
    applyHoistingAfterOfficeHour: 'workPermits/applyHoistingAfterOfficeHour',
    hoistingWAPPR: 'workPermits/hoistingWAPPR',
    hoistingAfterOfficeHourWAPPR: 'workPermits/hoistingAfterOfficeHourWAPPR',

    hoistingNextReviewer: 'workPermits/hoistingNextReviewer',
    nextReviewerWP: 'workPermits/nextReviewerWP',
    nextSecondReviewerWP: 'workPermits/nextSecondReviewerWP',
    nextApproverWP: 'workPermits/nextApproverWP',
    nextReviewerPP: 'workPermits/nextReviewerPP',
    nextApprover: 'workPermits/nextApprover',

    applyExtendWPToHkLandUser: 'workPermits/applyExtendWPToHkLandUser',
    applyExtendWPToContractor: 'workPermits/applyExtendWPToContractor',
    approveExtendWP: 'workPermits/approveExtendWP',
    rejectExtensionWP: 'workPermits/rejectExtensionWP',

    applyWpToContractor: 'workPermits/applyWpToContractor',
    applyHoistingToContractor: 'workPermits/applyHoistingToContractor',

    rejected: 'workPermits/rejected',
    suspendPP: 'workPermits/suspendPP',
    suspendWP: 'workPermits/suspendWP',
    resumedPP: 'workPermits/resumedPP',
    resumedWP: 'workPermits/resumedWP',

    approveNotificationPP: 'workPermits/approveNotificationPP',
    approveNotificationWP: 'workPermits/approveNotificationWP',
    approveNotificationHP: 'workPermits/approveNotificationHP',
  },
  directories: {
    waitForApproval: 'directories/waitForApproval',
    waitForProcessing: 'directories/waitForProcessing',
    approved: 'directories/approved',
    rejected: 'directories/rejected',
    submitted: 'directories/submitted',
  },
  jobs: {
    contactInfoConfirm: 'jobs/contactInfoConfirm',
  },
}

export const ActionTypes = {
  projects: createKeyMirror('projects', {
    invite: null,
    complete: null,
    cancel: null,
    doc: {
      create: null,
      delete: null,
    },
    relatedDoc: {
      create: null,
      delete: null,
    },
    deduction: {
      update: null,
      doc: {
        create: null,
        delete: null,
      },
    },
  }),
  rates: createKeyMirror('rates', {
    retention: {
      create: null,
      update: null,
    },
    complete: {
      create: null,
      update: null,
    },
  }),
  submissions: createKeyMirror('submissions', {
    submit: null,
    accept: null,
    reject: null,
    draft: null,
    unaccept: null,
  }),
  folders: createKeyMirror('folders', {
    accept: null,
    reject: null,
  }),
  settings: createKeyMirror('settings', {
    doc: {
      itq: {
        create: null,
        delete: null,
        edited: null,
      },
      tender: {
        create: null,
        delete: null,
        edited: null,
      },
      userGuide: {
        create: null,
        delete: null,
      },
      forms: {
        create: null,
        delete: null,
      },
      hotbTemplate: {
        create: null,
      },
    },
  }),
  accounts: createKeyMirror('accounts', {
    contractor: {
      subaccount: {
        update: null,
      },
    },
  }),
  tenders: createKeyMirror('tenders', {
    create: null,
    submit: null,
    approve: null,
    reject: null,
    cancel: null,
    issue: null,
    reset: null,
    decline: null,
    noshow: null,
    analysis: {
      create: null,
    },
    addendum: {
      create: null,
      submit: null,
      issue: null,
      reset: null,
      approve: null,
      reject: null,
      bid: {
        decline: null,
        submit: null,
      },
    },
    closingdate: {
      met: null,
      extend: null,
    },
    award: null,
    regret: null,
    threshold: {
      updated: null,
    },
    bid: {
      start: null,
      decline: null,
      submit: null,
      withdraw: null,
    },
  }),
  hotb: createKeyMirror('hotb', {
    submit: null,
    approve: null,
    reject: null,
    cancel: null,
    schedule: null,
    notifyUnsigned: null,
    complete: null,
    requestChange: null,
    changePIC: null,
    resetToDraft: null,
  }),
  tenantProjects: createKeyMirror('tenantProjects', {
    create: null,
    submit: null,
    approve: null,
    reject: null,
    cancel: null,
    withdraw: null,
    notifyUnsigned: null,
    complete: null,
    requestChange: null,
    resetToDraft: null,
    inProgress: null,
    filetypeChanged: {
      addDesignType: null,
      addTechnicalType: null,
      delDesignType: null,
      delTechnicalType: null,
    },
    designComment: {
      batchStatusChanged: null,
    },
  }),
  workPermits: createKeyMirror('workPermits', {
    submit: null,
  }),
  directories: createKeyMirror('directories', {
    saved: null,
    submitted: null,
    undo: null,
    delete: null,
    maintainOrder: {
      processed: null,
      saved: null,
    },
  }),
}

export const NotifyType = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
}

export const defaultTenderValidityPeriod = 180
export const maxAttachmentDescriptionLength = 255
export const noExpireCheckPages = [
  'login', 'publicLogin', 'vendorLogin', 'forgotPwd', 'resetPwd', 'notFound', 'contractorTermsOfUse', 'tenantTermsOfUse', 'adLogin', 'authenticationCode', 'unlockAccount', 'confirmUnlock', 'tenantPrivacyPolicy',
]

export const FORM_SRC_TENDER_QUERY = 'updateTenderQuery'

export const timeOptions = [
  '',
  '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
  '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30',
]

export const closingTimeOptions = ['12:00 Noon', '17:00']

export const envParameterNames = keyMirror({
  engineerEntry: null,
  vendorEntry: null,
})
export const workingHourAnytime = 'Anytime'
export const workingHourOptions = [
  workingHourAnytime,
  '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
  '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '23:59',
]
export const workingDayPublicHoliday = 'PH'
export const workingDayOptions = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
  workingDayPublicHoliday,
]

export const locationContactsDepartment = {
  propertyManagement: 'Property Management',
  assetManagement: 'Asset Management',
  technicalServices: 'Technical Services',
}

export const templateChip = {
  facility: '',
  description: '',
  files: [],
}

export const hotbTenantViewableStatus = ['SCHEDULED', 'UNSIGNED', 'COMPLETED']

export const TENANCY_ALL_PROJECTS_COMPONENT = 'TenancyAllProjects'
export const TENDER_QUERY_COMPONENT = 'TenderQuery'

export const tenancyViewTabs = {
  tenancyInformation: 0,
  allContacts: 1,
  allProjects: 2,
  sustainabilityInitiatives: 3,
  leaseInformation: 4,
  standaloneWorkPermits: 5,
  userManagement: 6,
}

export const TENANT_TENANCY_TABS = keyMirror({
  tenancyInformation: null,
  allContacts: null,
  allProjects: null,
  sustainabilityInitiatives: null,
  standaloneWorkPermits: null,
  userManagement: null,
})

export const ENGINEER_TENANCY_TABS = keyMirror({
  ...TENANT_TENANCY_TABS,
  leases: null,
})

export const tenancyTabsEditToView = [
  tenancyViewTabs.tenancyInformation,
  tenancyViewTabs.allContacts,
]

export const tenancyEditTabs = {
  tenancyInformation: 0,
  allContacts: 1,
  leaseInformation: 2,
  userManagement: 3,
}

export const tenancyTabsViewToEdit = [
  tenancyEditTabs.tenancyInformation,
  tenancyEditTabs.allContacts,
  tenancyEditTabs.leaseInformation,
  tenancyEditTabs.userManagement,
]

export const tenantProjectTabs = {
  projectInfo: 0,
  submissions: 1,
  contractorInfo: 2,
  workPermit: 3,
  projectContr: 4,
}

export const tenantTabsViewArr = [
  tenantProjectTabs.projectInfo,
  tenantProjectTabs.submissions,
  tenantProjectTabs.projectContr,
]

export const TREE_STATUS = createKeyMirror('TREE_STATUS', {
  selected: null,
  unselected: null,
  selectPart: null,
  added: null,
})

export const operationType = {
  VIEW: 'VIEW',
  DEL: 'DEL',
  ADD: 'ADD',
}

export const templateType = keyMirror({
  ECIRCULAR_TENANT_DEPARTMENT_FOOTER: null,
  ECIRCULAR_TENANT_DEPARTMENT_HEADER: null,
  ECIRCULAR_TENANT_DEFAULT: null,
  ECIRCULAR_TENANT: null,
  ECIRCULAR_VENDOR: null,
  FITOUT: null,
  REINSTATEMENT: null,
  POST_FITOUT: null,
  GREEN_FITOUT: null,
  GREEN_OPERATION: null,
})

export const templateTitle = keyMirror({
  Opening: null,
  Closing: null,
  Description: null,
})

export const tenantProjectViewTabs = {
  projectInfo: 0,
  submissions: 1,
  contractorInfo: 2,
  workPermit: 3, // <!-- hotfix HKLDCMS-17266  -->
  projectControl: 4,
}

export const projectControlAchorIds = {
  deposit: 'project-control-deposit-Amount',
  managementFee: 'project-control-management-fee',
  insurance: 'project-control-insurance',
  workPermit: 'project-control-work-permit',
  finalDocuments: 'project-control-final-docs',
  inspection: 'project-control-inspection',
}

export const lifecycleCommentAttrs = {
  rejectReason: 'rejectReason',
  comments: 'comments',
}

export const DOCS_SOURCE_TYPE = {
  USER_GUIDE: 'hklsettinguserguidefiles',
  FORMS: 'hklsettingpageformsfiles',
}

export const MIME_TYPES = {
  ALL: 'application/*,audio/*,image/*,message/*,model/*,multipart/*,text/*,video/*, ,',
}

export const FEATURE_NAMES = keyMirror({
  TENDERS: null,
  HONGKONG_LAND_PROJECTS: null,
  TENANCY_RECORDS: null,
  TENANT_PROJECTS: null,
  WORK_PERMITS: null,
  VENDOR_PERFORMANCE: null,
  E_CIRCULAR: null,
  DIRECTORY: null,
  GREEN_OPERATION: null,
  GREEN_FIT_OUT: null,
})

export const PUBLIC_PORTAL_FEATURE_MAPPING = {
  VENDOR_PORTAL: [FEATURE_NAMES.TENDERS, FEATURE_NAMES.HONGKONG_LAND_PROJECTS],
  TENANT_PORTAL: [FEATURE_NAMES.TENANCY_RECORDS],
}

export const featureSecurityGroupMapping = {
  TENDERS: ['ITQ/Tender'],
  HONGKONG_LAND_PROJECTS: ['Project'],
  TENANCY_RECORDS: ['TenancyRecord', 'MoveInOut', 'ExportContact'],
  TENANT_PROJECTS: ['EngineerTenantProject', 'Handover/Takeback'],
  WORK_PERMITS: ['WorkPermit'],
  VENDOR_PERFORMANCE: ['Performance'],
  E_CIRCULAR: ['TenantECircular', 'VendorECircular'],
  DIRECTORY: ['Directory'],
}

export const securityGroupFeatureMapping = {
  TenantECircular: [['E_CIRCULAR', 'TENANCY_RECORDS']],
  VendorECircular: [['E_CIRCULAR', 'TENDERS'], ['E_CIRCULAR', 'HONGKONG_LAND_PROJECTS']],
}

export const defaultSecurityGroups = ['Settings', 'Contact', 'Contractor', 'Tenant', 'Organization']

export const featureSettingsMapping = {
  TENDERS: [ROUTER_PATHS.GENERAL_DOCS],
  TENANT_PROJECTS: [ROUTER_PATHS.GUIDELINE],
  E_CIRCULAR: [ROUTER_PATHS.TENANT_SIGNATURE_TEMPLATE],
}

export const defaultSettings = [
  ROUTER_PATHS.SETTING_USERS,
  ROUTER_PATHS.DEPARTMENT,
  ROUTER_PATHS.SITES,
  ROUTER_PATHS.BUILDING_LIST,
  ROUTER_PATHS.SECURITY_GROUP,
  ROUTER_PATHS.UPLOADED_FILE_SETTINGS,
  ROUTER_PATHS.AUDIT_LOG,
  ROUTER_PATHS.AUDIT_REPORT,
  ROUTER_PATHS.USER_GUIDE_FORMS_MANAGE,
  ROUTER_PATHS.REGION_CONFIG,
  ROUTER_PATHS.SYSTEM_MAPPING_LIST,
]

export const regionNames = {
  BJ: 'BJ',
  HK: 'HK',
  SG: 'SG',
  MO: 'MO',
  global: 'GLOBAL',
}

export const emptyValue = '--'
